import {USER_ROLES, WEBBACK_V2_API} from "@constants";
import {useUserApp} from "@hooks";

const V2_DIGITAL_SHELF = `${WEBBACK_V2_API}/digital-shelf`

// **On dipi-webback-v2 since 2026-08-12**, and the url no longer depends on the role.
//
// v1 branched to a `digital-shelf-seller` nested for `USER_ROLES.MARKETPLACES`, reading
// `DATA_DIGITAL_SHELF_BY_SELLER`. That branch is **not migrated and not coming back**: its only
// customer was Lego, which is out, and it was the only one with `has_main_seller = 1` — the three
// live customers have it at `0`, so the endpoint has no user. Pointing a role at
// `/digital-shelf-seller` on v2 would 404: it does not exist there.
// See dipi-webback-v2/plans/869e5pfw2--data-digital-shelf.md §0 ("lo que NO entra").
//
// ⚠️ `pp_kpi` (Product Page Score) comes back `null` for now — `DATA_DIGITAL_SHELF` is not in OLAP
// and the KPI is being rebuilt from `PRODUCT_PAGE` by another team member (§0.bis of that plan).
// The table already renders it as `N/A`, so nothing to do here; it will start showing values on its
// own once the back returns them.

export default function useDigitalShelfRoleConfig() {
	const { userRole } = useUserApp()

	return {
		urlApi: `${V2_DIGITAL_SHELF}/context`,
		urlApiEvolution: `${V2_DIGITAL_SHELF}/evolution`,
		urlApiExcel: `${V2_DIGITAL_SHELF}/excel`,
		isMarketplacesUser: userRole === USER_ROLES.MARKETPLACES
	}
}
